var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeveloper(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70.6533,
    height: 70.6533,
    rx: 12,
    fill: "#E5FFFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0466 48.4636C48.9945 48.2661 49.5612 47.2735 49.089 46.4252C48.0483 44.5585 46.4101 42.9168 44.315 41.6666C41.6154 40.0559 38.3063 39.1818 34.9061 39.1818C31.5059 39.1818 28.1967 40.0541 25.4972 41.6666C23.4021 42.9168 21.7638 44.5585 20.7232 46.4252C20.2509 47.2735 20.8176 48.2661 21.7655 48.4636C30.4322 50.2699 39.3782 50.2699 48.0449 48.4636",
    fill: "#00A48C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9061 37.4645C39.6482 37.4645 43.4924 33.6203 43.4924 28.8781C43.4924 24.136 39.6482 20.2918 34.9061 20.2918C30.164 20.2918 26.3198 24.136 26.3198 28.8781C26.3198 33.6203 30.164 37.4645 34.9061 37.4645Z",
    fill: "#00A48C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloper);
export default __webpack_public_path__ + "static/media/developer.75f78e4b4672d35cfded5f8b1fd12115.svg";
export { ForwardRef as ReactComponent };